import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {Col, Row} from "reactstrap";
import {useDisclosure} from "../../hooks/useDisclosure";
import CommonHeader from "../Headers/CommonHeader";
import AddDashboard from "../Modal/AddDashboard";
import DashboardCard from "./DashboardCard";

function DashboardCards(props) {
  const {
    dashboards,
    isEditable = false,
    updateCallback = () => {},
    columnWidth = 3,
    type = "Dashboard",
    onCardClick = () => {},
  } = props;
  const {isOpen: isModalOpen, onOpen: openModal, onClose: closeModal} = useDisclosure();

  /** This component will list dashboard card component in grid layout */

  return (
    <Fragment>
      {isEditable && (
        <div>
          <CommonHeader
            content={`Add ${type}`}
            handleAddClick={openModal}
            testID={"add_dashboard"}
          />
        </div>
      )}
      {isModalOpen && (
        <AddDashboard
          open={isModalOpen}
          handleClose={closeModal}
          updateCallback={updateCallback}
          headerName={type}
        />
      )}
      <div>
        <Row>
          {dashboards &&
            dashboards.map((dashboard) => (
              <Col key={dashboard.id} md={6} lg={4} xl={columnWidth}>
                <DashboardCard
                  dashboard={dashboard}
                  isEditable={isEditable}
                  type={type}
                  onCardClick={onCardClick}
                  updateCallback={updateCallback}
                />
              </Col>
            ))}
        </Row>
      </div>
    </Fragment>
  );
}

DashboardCards.propTypes = {
  type: PropTypes.string, //Name for add dashboard header
  dashboards: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      meta: PropTypes.shape({updatedAt: PropTypes.instanceOf(Date)}),
    })
  ).isRequired,
  isEditable: PropTypes.bool,
  /** Number of columns to show in single row of grid layout */
  columnWidth: PropTypes.number,
  /** This callback will be executed after Add, edit, delete and handoff of dashboard */
  updateCallback: PropTypes.func,
  /** Callback which will be executed when clicked on card */
  onCardClick: PropTypes.func,
};

export default DashboardCards;
